<template>
    <ClientOnly>
        <div class="relative">
            <div id="hubspotForm1" class="hbspt-form hbspt-form-extended"></div>
        </div>
    </ClientOnly>
</template>

<script>
export default {
    name: 'CustomerServiceHubspotForm',
    props: {
        card: {
            type: Boolean,
            required: false,
            default: false,
        },
        game: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    mounted() {
        const formId =
            this.$i18n.locale === 'hu'
                ? 'eb93a761-e747-4072-9353-f745d3fb33ea'
                : '79ea47ff-051e-490e-ae79-1740d4f1c0cd';

        window.hbspt.forms.create({
            portalId: '6087627',
            formId,
            target: '#hubspotForm1',
        });
    },
};
</script>

<style></style>
